import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import Tabs from 'components/shared/tabs/component';
import Loader from 'components/shared/loader/component';
import MainTable from 'components/shared/tables/mainTable/component';
import GamesTableConfig from 'components/configs/mainTable/gamesTable/GamesTableConfig';
import Pagination from 'components/shared/pagination/component';
import { setT } from 'helpers/translationUtilities';
import { USER_TYPE_ADMIN } from '../../../../types/user-types';
import { PURGE_ALL_APP_DATA } from 'components/constants';
import { getGamesAction } from '../../../../redux/actions/shared.actions';
import { adminSelectGameAction } from '../../../../redux/actions/admin/admin.actions';
var GAME_STATE_ACTIVE = 'ACTIVE';
var GAME_STATE_ENDED = 'ENDED';
GamesListing.propTypes = {
    isFacilitatorOrigin: PropTypes.bool
};
export default function GamesListing(_a) {
    var _b = _a.isFacilitatorOrigin, isFacilitatorOrigin = _b === void 0 ? false : _b;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var userAuthorization = useSelector(function (state) { return state.userAuthorization; });
    var games = useSelector(function (state) { return state.general.games; });
    var gamesPaginationMaxPages = useSelector(function (state) { return state.userInterface.gamesPaginationMaxPages; });
    var gamesListRequested = useSelector(function (state) { return state.userInterface.gamesListRequested; });
    var token = userAuthorization.token, _c = userAuthorization.userSession, rank = _c.rank, name = _c.name;
    var _d = useState(GAME_STATE_ACTIVE), activeTab = _d[0], setActiveTab = _d[1];
    var _e = useState(15), itemsPerPage = _e[0], setItemsPerPage = _e[1];
    var _f = useState(1), currentPage = _f[0], setCurrentPage = _f[1];
    var dropdownOptions = [
        { id: 1, value: 15, label: 15 },
        { id: 2, value: 30, label: 30 },
        { id: 3, value: 45, label: 45 }
    ];
    var TabsConfig = {
        tabs: [
            { id: GAME_STATE_ACTIVE, label: setT('active'), onClickEvent: function () { return setActiveTab(GAME_STATE_ACTIVE); }, active: activeTab === GAME_STATE_ACTIVE },
            { id: GAME_STATE_ENDED, label: setT('ended'), onClickEvent: function () { return setActiveTab(GAME_STATE_ENDED); }, active: activeTab === GAME_STATE_ENDED }
        ]
    };
    useEffect(function () {
        if (token) {
            dispatch(getGamesAction(token, { page: currentPage, perPage: itemsPerPage, status: activeTab }));
        }
        else {
            dispatch({ type: PURGE_ALL_APP_DATA });
            navigate('/login');
        }
        if (currentPage > gamesPaginationMaxPages) {
            setCurrentPage(gamesPaginationMaxPages);
        }
    }, [itemsPerPage, currentPage, token, gamesPaginationMaxPages, activeTab]);
    var isAdmin = [USER_TYPE_ADMIN].includes(rank);
    var isExceptionUser = ['Admin', 'Tallinna Ettevõtlusküla', 'Tartu Ettevõtlusküla'].includes(name);
    var canAccessGameCreate = isAdmin || isExceptionUser;
    return (React.createElement("div", { className: "games-list loader-container" },
        React.createElement("div", { className: "games-list__header" },
            React.createElement("div", { className: "games-list__button" }, canAccessGameCreate ? (React.createElement(Link, { to: "/new-game".concat(isFacilitatorOrigin ? '?origin=facilitator' : ''), className: "main-button main-button--notice main-button--lg" }, setT('add_new_game'))) : (React.createElement("a", { href: "https://my.bizplay.ee/et/loo-mang/", className: "main-button main-button--notice main-button--lg" }, setT('add_new_game')))),
            React.createElement("div", { className: "games-list__tabs" },
                React.createElement(Tabs, { config: TabsConfig }))),
        gamesListRequested ? (React.createElement("div", { className: "d-flex flex-justify-content-center games-list__loader" },
            React.createElement(Loader, null))) : (React.createElement(Fragment, null,
            React.createElement(MainTable, { config: GamesTableConfig({ games: games, selectGame: function (id) { return dispatch(adminSelectGameAction(id)); } }) }),
            React.createElement("div", { className: "games-list__pagination" },
                React.createElement(Pagination, { itemsPerPage: { dropdownOptions: dropdownOptions, currentPerPage: itemsPerPage, setItemsPerPage: function (value) { return setItemsPerPage(value); } }, pages: {
                        currentPage: currentPage,
                        maxPages: gamesPaginationMaxPages,
                        onPrevPage: function () { if (currentPage !== 1)
                            setCurrentPage(currentPage - 1); },
                        onNextPage: function () { if (currentPage !== gamesPaginationMaxPages)
                            setCurrentPage(currentPage + 1); }
                    } }))))));
}
